import "./Line.css";

const Line = () => {
  return <div className="line" />;
};

export default Line;
